import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  taskContainer: {
    height: "320px",
    maxWidth: "445px",
    padding: "10px",
    boxShadow: "0px 0px 25px rgba(0,0,0,0.1)",
    borderRadius: "6px",
    fontFamily: "Lato",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
    },
    textDecoration: "none",
    color: "black",
  },
  titleDescription: {
    height: "76%",
    overflow: "hidden",
    width: "100%",
  },
  taskTitle: () => ({
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 400,
    fontFamily: "Lato",
    color: "#45547C",
    textOverflow: "ellipsis",
    overflow: "hidden",
  }),
  taskDescription: () => ({
    marginTop: "5px",
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    fontFamily: "Lato",
    color: "#0F172A",
    lineHeight: "19.2px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      lineHeight: "24px",
      marginBottom: "10px",
    },
  }),
  infoContainer: {
    height: "70px",
  },
  dueDateContainer: () => ({
    color: "#45547C",
    fill: "#45547C",
  }),
  dueDateIcon: {
    width: "11px",
    height: "24px",
  },
  dueDate: {
    marginLeft: "5px",
    fontSize: theme.typography.pxToRem(12),
    fontFamily: "Lato",
    fontWeight: 400,
  },
  completedLabel: () => ({
    backgroundColor: "#D3F7F1",
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    padding: "4px 12px",
  }),
  notCompletedLabel: {
    backgroundColor: "#EDF0F3",
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    padding: "4px 12px",
  },
  scoreContainer: () => ({
    fontFamily: "Lato",
    backgroundColor: "#FFEFEC",
    borderRadius: "4px",
    padding: "4px 12px",
  }),
  scoreNumber: {
    fontSize: theme.typography.pxToRem(14),
    fontFamily: "Lato",
    fontWeight: 700,
  },
  scoreText: {
    fontSize: theme.typography.pxToRem(10),
    fontFamily: "Lato",
    marginLeft: "1px",
    fontWeight: 600,
  },
}));
